import React, { useState, useEffect } from "react";
import { dbRefProjects } from "../../../firebase-config";
import { onValue } from "firebase/database";
import ProjectCard from "../ProjectCard";
import FishPopup from "../../FishPopup";

import "bootstrap/dist/css/bootstrap.min.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "../../Shared/Button";
import "../ProjectGallery/projectGallery.css";
import "../ProjectCard/projectCard.css";
import "./projectSection.css";

const ProjectSection = ({}) => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);

  const [projects, setProjects] = useState([]);

  useEffect(() => {
    onValue(dbRefProjects, (snapshot) => {
      const projectsData = snapshot.val();
      const projectKeys = Object.keys(projectsData); // Retrieve the keys/uids
      const projectsWithKeys = projectKeys.map((key) => ({
        ...projectsData[key],
        uid: key, // Add uid/key to each project item
      }));
      const mergedProjects = [...projects, ...projectsWithKeys]; // Merge the arrays
      setProjects(mergedProjects);
    });
  }, []); // Empty dependency array for initial fetching

  return (
    <div className="projectSection">
      <Row>
        <Col xs={12} md={12} style={{ float: "left" }}>
          <h3>Our projects</h3>
        </Col>
      </Row>

      <Row>
        <p>
          We are constantly pushing our portfolio of inspiring and explorative
          projects, and currently we have projects in the fields of OpenAI,
          Robotics, and Immersive tech.
        </p>
        <p>
          Please check out our projects, perhaps you want to know more or sign
          up for one of them.
        </p>
      </Row>
      <div className="project-section-button-container">
        <Button
          buttonStyle="pink"
          text="See all projects here"
          navigateTo="/projects"
        />
      </div>

      <Row className="gallery-container">
        {Object.values(projects).map((project) => (
          <Col
            key={"col" + project.uid}
            xs={12}
            md={3}
            style={{ display: "flex", flexWrap: "wrap" }}
          >
            <ProjectCard
              key={project.uid}
              image={project.imgUrl}
              title={project.title}
              description={project.description}
            />
          </Col>
        ))}
      </Row>
      <FishPopup show={showModal} handleClose={handleClose} />
    </div>
  );
};
export default ProjectSection;
